import { render, staticRenderFns } from "./PCExtExams.vue?vue&type=template&id=c8c206cc&scoped=true&"
import script from "./PCExtExams.vue?vue&type=script&lang=js&"
export * from "./PCExtExams.vue?vue&type=script&lang=js&"
import style0 from "./PCExtExams.vue?vue&type=style&index=0&id=c8c206cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c206cc",
  null
  
)

export default component.exports